import { render, staticRenderFns } from "./RelatedUsersMain.vue?vue&type=template&id=48c8c78c&"
import script from "./RelatedUsersMain.vue?vue&type=script&lang=js&"
export * from "./RelatedUsersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports